export enum stateStatus {
  initialized,
  loading,
  loaded,
}
